'use client';

import { type ReactNode, createContext, useContext, useRef } from 'react';
import { type StoreApi, useStore } from 'zustand';
import { QuoteStoreOptions, type Store, createQuoteStore } from './store';

export const QuoteStoreContext = createContext<StoreApi<Store> | null>(null);

export type QuoteStoreProviderProps = QuoteStoreOptions & {
	children: ReactNode;
};

export const QuoteStoreProvider = ({ children, devtoolsEnabled, storage }: QuoteStoreProviderProps) => {
	const storeRef = useRef<StoreApi<Store>>();

	if (!storeRef.current) {
		storeRef.current = createQuoteStore({ devtoolsEnabled, storage });
	}

	return <QuoteStoreContext.Provider value={storeRef.current}>{children}</QuoteStoreContext.Provider>;
};

export const useQuoteStore = <T,>(selector: (store: Store) => T): T => {
	const quoteStoreContext = useContext(QuoteStoreContext);

	if (!quoteStoreContext) {
		throw new Error('useQuoteStore must be use within QuoteStoreProvider');
	}

	return useStore(quoteStoreContext, selector);
};
